import React, { useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Flex,
  HStack,
  Text,
  Icon,
  useColorModeValue,
  Collapse,
} from '@chakra-ui/react';
import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';

export function SidebarLinks(props) {
  let location = useLocation();
  let navigate = useNavigate();
  let activeColor = useColorModeValue('gray.700', 'gray.700');
  let activeIcon = useColorModeValue('brand.500', 'gray.700');
  let inactiveIcon = useColorModeValue('secondaryGray.500', 'secondaryGray.600');
  let textColor = useColorModeValue('secondaryGray.500', 'white');

  const { routes } = props;
  const [openDropdowns, setOpenDropdowns] = useState({});

  const toggleDropdown = (name, hasChildren) => {
    if (hasChildren) {
      setOpenDropdowns((prev) => ({
        ...prev,
        [name]: !prev[name],
      }));
    }
  };

  const handleMainClick = (route) => {
    if (route.children) {
      // Expand the dropdown
      setOpenDropdowns((prev) => ({
        ...prev,
        [route.name]: true,
      }));
    }
    // Navigate to the main page
    navigate(route.layout + route.path);
  };

  const activeRoute = (routeName) => {
    return location.pathname.includes(routeName);
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (route.children) {
        return (
          <Box key={index}>
            <Flex
              align="center"
              justify="space-between"
              py="5px"
              ps="10px"
              bg={activeRoute(route.path) ? 'gray.200' : 'transparent'}
              borderRadius="10px"
              px="10px"
              mt="10px"
            >
              {/* Main Link */}
              <Flex
                align="center"
                flex="1"
                onClick={() => handleMainClick(route)}
                cursor="pointer"
              >
                <HStack spacing="22px" mb="-7px">
                  <Box color={activeRoute(route.path) ? activeIcon : inactiveIcon}>
                    {route.icon}
                  </Box>
                  <Text
                    me="auto"
                    color={activeRoute(route.path) ? activeColor : textColor}
                    fontWeight={activeRoute(route.path) ? 'bold' : 'normal'}
                    mt="-7px"
                  >
                    {route.name}
                  </Text>
                </HStack>
              </Flex>
              {/* Dropdown Icon */}
              <Icon
                as={openDropdowns[route.name] ? ChevronUpIcon : ChevronDownIcon}
                color={textColor}
                cursor="pointer"
                w="20px"
                h="20px"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents triggering the main link navigation
                  toggleDropdown(route.name, true);
                }}
              />
            </Flex>
            {/* Subpages */}
            <Collapse in={openDropdowns[route.name]}>
              <Box pl="8">{createLinks(route.children)}</Box>
            </Collapse>
          </Box>
        );
      }

      // For routes without children
      return (
        <NavLink key={index} to={route.layout + route.path}>
          <Flex
            align="center"
            py="5px"
            ps="10px"
            bg={activeRoute(route.path) ? 'gray.200' : 'transparent'}
            borderRadius="10px"
            px="10px"
            mt="10px"
          >
            <HStack spacing="22px" mb="-7px">
              <Box color={activeRoute(route.path) ? activeIcon : inactiveIcon}>
                {route.icon}
              </Box>
              <Text
                me="auto"
                color={activeRoute(route.path) ? activeColor : textColor}
                fontWeight={activeRoute(route.path) ? 'bold' : 'normal'}
                mt="-7px"
              >
                {route.name}
              </Text>
            </HStack>
          </Flex>
        </NavLink>
      );
    });
  };

  return createLinks(routes);
}

export default SidebarLinks;
